module.exports = __webpack_public_path__ + "static/turtle-creek-house43-238d495012d23a7e9241157269ff656f.jpg";